/**
 * 设备状态
 * @type {{FREE: number, RUNNING: number, ERROR: number}}
 */
const DEVICE_STATUS = {
  FREE: 0,
  RUNNING: 1,
  ERROR: 2,
};
/**
 * 设备上文件的状态
 * @type {{ONDEVICE: string, ONSERVER: string}}
 */
const DEVICE_FILE_STATUS = {
  ONSD: 'ONSD', // 在内存卡中
  ONUDISK: 'ONUDISK', // 在U盘中
  ONSERVER: 'ONSERVER', // 在服务器上
};
/**
 * 设备在线状态
 * @type {{ONLINE: number, OFFLINE:number}}
 */
const DEVICE_ONLINE = {
  OFFLINE: 0,
  ONLINE: 1,
};
/**
 * 设备网络状态
 * @type {{UNKNOWN: number, LOCAL_WIFI: number, HOTSPOT_WIFI: number, FOURTH_G: number}}
 */
const DEVICE_NET_STATUS = {
  UNKNOWN: 0,
  LOCAL_WIFI: 1,
  HOTSPOT_WIFI: 2,
  FOURTH_G: 3,
};
/**
 * 面板状态
 * @type {{FREE: number, RUNNING: number}}
 */
const PANEL_STATUS = {
  /**
   * 空闲
   */
  FREE: 0,
  WAITING: 1,
  RUNNING: 2,
};
/**
 * 工程状态
 * @type {{FREE: number, RUNNING: number}}
 */
const PROJECT_STATUS = {
  /**
   * 空闲
   */
  FREE: 0,
  WAITING: 1,
  RUNNING: 2,
};
/**
 * 工作页参考页
 * @type {{REFERENCE: number, WORKING: number}}
 */
const CAN_PAGE = {
  REFERENCE: 0,
  WORKING: 1,
};
/**
 * 组件类型
 * @type {{Oscillogram: number, DASHBOARD: number, INPUT: number, SEND: number,
 * PIC: number, SWITCHER: number, OUTPUT: number，CUSTOMFRAMES:number, CUSTOMCOMPONENT:number}}
 */
const COMPONENT_TYPE = {
  Oscillogram: 1, // 示波器
  DASHBOARD: 2, // 仪表盘
  INPUT: 3, // 标定量输入
  SEND: 4, // 发送
  PIC: 5, // 图片组件
  SWITCHER: 6, // 枚举图
  OUTPUT: 7, // 单数据显示
  MAP: 8, // 百度地图组件
  UDS: 9, // UDS组件
  VIDEO: 10, // 视频组件
  CUSTOMFRAMES: 11, // 自定义帧
  SLIDER: 13, // 滑动组件
  NUMERICINDICATOR: 14, // 显示组件
  NUMERICCONTROL: 15, // 控制组件
  TRIGGER: 16, // 触发器组件
  CONDITION: 17, // 条件判断组件
};
/**
 * 发送组件的发送类型
 * @type {{NOW: string, CYCLE: string}}
 */
const COM_SEND_TYPE = {
  NOW: 'NOW',
  CYCLE: 'CYCLE',
};
/**
 * 数据源的类型
 * @type {{DBC_MSG: number, DBC_SIGNAL: number, DEMARCATE: number, MEASURE: number}}
 */
const DATASOURCE_TYPE = {
  /**
   * dbc下的消息
   */
  DBC_MSG: 0,
  /**
   * dbc下的信号
   */
  DBC_SIGNAL: 1,
  /**
   * A2L的标定量
   */
  DEMARCATE: 2,
  /**
   * A2L的观测量
   */
  MEASURE: 3,
};
/**
 * 工程左侧树状结构的节点类型
 * @type {{CAN: number, ECUS: number, SYSTEM_VARIABLES: number, DBC_ROOT: number,
 * DBC_MSG_ROOT: number, DBC_SIGNAL_ROOT: number, DBC_MSG: number, DBC_SIGNAL: number,
 * A2L_ROOT: number, A2L_MEASURE: number, A2L_CHARACTER: number, DEVICE: number, DEVICE_HW: number}}
 */
const PROJECT_NODE_TYPE = {
  /**
     * CAN配置节点
     */
  CAN: 0,
  /**
     * ECU配置根节点
     */
  ECUS: 1,
  /**
     * 系统变量的配置根节点
     */
  SYSTEM_VARIABLES: 2,
  /**
     * DBC根节点，可用来添加DBC
     */
  DBC_ROOT: 3,
  /**
     * DBC的Message的根节点，空节点，只为了组织结构
     */
  DBC_MSG_ROOT: 4,
  /**
     * DBC的信号的根节点，空节点，只为了组织结构
     */
  DBC_SIGNAL_ROOT: 5,
  /**
     * DBC的Message节点，方便用来设计逻辑，拖拽到发送组件
     */
  DBC_MSG: 6,
  /**
     * DBC的信号节点，方便用来设计逻辑，拖拽到相关组件
     */
  DBC_SIGNAL: 7,
  /**
     * DBC的时间节点，
     */
  DBC_TIME: 8,
  /**
     * DBC的Trigger节点，
     */
  DBC_TRIGGER: 9,
  /**
     * A2L根节点，可用来添加A2L文件
     */
  A2L_ROOT: 10,
  /**
     * a2l根节点Excel
     */
  A2l_EXCEL: 101,
  /**
     * A2L的观测量节点，方便用来设计逻辑，拖拽到相关组件
     */
  A2L_MEASURE: 11,
  /**
     * A2L的标定量节点，方便用来设计逻辑，拖拽到标定量输入组件
     */
  A2L_CHARACTER: 12,
  /**
     * 设备节点
     */
  DEVICE: 20,
  /**
     * 设备下的硬件节点，类似于CAN，其下默认会有一个DBC_ROOT
     */
  DEVICE_HW: 21,
  /**
     * UDS根节点，可以用来添加UDS诊断模板文件
     */
  UDS_ROOT: 30,
  /**
     * UDS模板信息的抽象节点，对外展示模板文件信息，向UDS组件传递当前的设备信息、通道信息
     */
  UDS_INFO: 31,
}
;
/**
 * CAN通道类型
 * @type {{commonCan: number, FDCan: number, HwCan, number}}
 */
const CAN_TYPE = {
  /**
     * 普通的CAN通道
     */
  commonCan: 0,
  /**
     * 支持CANFD的通道
     */
  FDCan: 1,
  /**
     * 硬件线路上的CAN通道
     */
  HwCan: 2,
};
/**
   * 自定义组件种类
   * @type {{REFERENCE: number, WORKING: number}}
   */
const CUSTOM_COMPONENT_GROUP_TYPE = {
  NUMERICS: '0',
  BOOLEANS: '1',
  PULL_DOWNS: '2',
  CHARTS: '3',
  DASHBOARDS: '4',
}
;

export {
  DEVICE_STATUS,
  DEVICE_FILE_STATUS,
  DEVICE_ONLINE,
  DEVICE_NET_STATUS,
  COMPONENT_TYPE,
  COM_SEND_TYPE,
  DATASOURCE_TYPE,
  PROJECT_NODE_TYPE,
  PANEL_STATUS,
  CAN_PAGE,
  CAN_TYPE,
  CUSTOM_COMPONENT_GROUP_TYPE,
};



// WEBPACK FOOTER //
// ./src/common/enums.js